module.exports = __webpack_public_path__ + "static/img/4.643c8c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/eng/4.png
// module id = Yv7s
// module chunks = 0